module.exports = __webpack_public_path__ + "static/media/multi_opti.4c8c6f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/multi_opti.png
// module id = 109
// module chunks = 0